require('./vendor/jquery.min');
require('./main');

